import { useEffect } from "react";
import { Switch, Route, useLocation } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";
import { ThemeProvider } from "@/components/ThemeProvider";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import About from "@/pages/About";
import Login from "@/pages/Login";
import Orders from "@/pages/Orders";
import Addresses from "@/pages/Addresses";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentFailure from "@/pages/PaymentFailure";
import NotFound from "@/pages/not-found";

function HideWhatsAppOnBooking({ children }: { children: React.ReactNode }) {
  const [location] = useLocation();
  if (location === '/booking') {
    return null;
  }
  return <>{children}</>;
}

function ScrollToTop() {
  const [location] = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  
  return null;
}

function Router() {
  return (
    <>
      <ScrollToTop />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/login" component={Login} />
        <Route path="/booking">
          <ProtectedRoute>
            <Booking />
          </ProtectedRoute>
        </Route>
        <Route path="/orders">
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        </Route>
        <Route path="/addresses">
          <ProtectedRoute>
            <Addresses />
          </ProtectedRoute>
        </Route>
        <Route path="/payment/success" component={PaymentSuccess} />
        <Route path="/payment/failure" component={PaymentFailure} />
        <Route path="/about" component={About} />
        <Route component={NotFound} />
      </Switch>
    </>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <Navigation />
        <main>
          <Router />
        </main>
        <Toaster />
        <Footer />
        <HideWhatsAppOnBooking>
          <WhatsAppFab />
        </HideWhatsAppOnBooking>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
